import { RadioButton } from "primereact/radiobutton";
import React, { useEffect, useState } from "react";
import LineLevelSchemedisc from "./LineLevelSchemedisc";
import SchemeDiscountDefinition from "./SchemeDiscountDefinition";
import { useSearchParams } from "react-router-dom";

function SchemeDiscMast() {
  const [activeScheme, setActiveScheme] = useState("");
  const [searchParams] = useSearchParams();
  const schmCode = searchParams.get("schmID");
  useEffect(() => {
    const discTypeid = searchParams.get("Schmtype");

    if (discTypeid == "FlatDisc") {
      setActiveScheme("FlatDisc");
    } else if (discTypeid == "LineLvl") {
      setActiveScheme("linelvlDisc");
    }else{
        setActiveScheme("FlatDisc");
    }
  }, [searchParams]);
  return (
    <>
      <div className="col-12 mb-3">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mx-0">
              <li className="breadcrumb-item">Masters</li>
              <li className="breadcrumb-item" aria-current="page">
                Scheme
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Scheme Discount Definition
              </li>
            </ol>
          </nav>
        </div>
        <div className="dashed-brdr-bottom mb-2 pb-2 d-flex justify-content-center align-items-center">
          <div className="d-inline-flex">
            <div className="flex align-items-center me-3">
              <RadioButton
                inputId="SchemDisc"
                name="FlatDisc"
                value="FlatDisc"
                onChange={(e) => setActiveScheme(e.value)}
                checked={activeScheme === "FlatDisc"}
                disabled={schmCode !== "null"}
              />
              <label htmlFor="SchemDisc" className="form-label ms-2 mb-0">
                Flat Discount
              </label>
            </div>
            <div className="flex align-items-center">
              <RadioButton
                inputId="SchemDisc1"
                name="linelvlDisc"
                value="linelvlDisc"
                onChange={(e) => setActiveScheme(e.value)}
                checked={activeScheme === "linelvlDisc"}
                disabled={schmCode !== "null"}
              />
              <label htmlFor="SchemDisc1" className="form-label ms-2 mb-0">
                Line Level Discount
              </label>
            </div>
          </div>
        </div>
      </div>
      {activeScheme === "FlatDisc" ? (
        <SchemeDiscountDefinition />
      ) : (
        <LineLevelSchemedisc />
      )}
    </>
  );
}

export default SchemeDiscMast;
